import React from "react";
import { AuditLogRole } from "../../../../../models/Entities";
import { Typeahead } from "@merge-api/merge-javascript-shared";
import { ROLE_LABEL } from "../constants";

const ROLE_OPTIONS = Object.values(AuditLogRole).sort((a, b) =>
  ROLE_LABEL[a].localeCompare(ROLE_LABEL[b]),
);

type RolePickerProps = {
  role: AuditLogRole | null;
  onRoleChange: (role: AuditLogRole | null) => void;
};

const RolePicker = ({ role, onRoleChange }: RolePickerProps) => {
  return (
    <Typeahead
      placeholder="Search roles..."
      options={ROLE_OPTIONS}
      value={role}
      getOptionLabel={(option) => ROLE_LABEL[option as AuditLogRole] ?? option}
      onChange={(_: any, selected: AuditLogRole | null) => onRoleChange(selected)}
    />
  );
};

export default RolePicker;
